import { render, staticRenderFns } from "./streetmain.vue?vue&type=template&id=688d5dec&scoped=true&"
import script from "./streetmain.vue?vue&type=script&lang=js&"
export * from "./streetmain.vue?vue&type=script&lang=js&"
import style0 from "./streetmain.vue?vue&type=style&index=0&id=688d5dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688d5dec",
  null
  
)

export default component.exports